/**
Project: Voice Panel (c)
Title: Departments Row 
Description: Component for add/update departments
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
    TableRow,
    EditIcon,
    TableCell,
    Button,
    Input,
    CloseIcon,
    AcceptIcon,
    TrashCanIcon
} from "@fluentui/react-northstar";
import Textfy from "react-texty";
import { Fragment } from "react";

export const AdminDepartmentsRow = ({
    department,
    handleUpdateDepartment,
    clearAlert,
    showForm,
    handleOpenForm,
    handleCloseForm,
    handleDeleteDepartment,
}) => {
    const [inEditMode, setInEditMode] = useState({ status: false, rowKey: null });
    const [departmentName, setDepartmentName] = useState("");
    const [departmentNotes, setDepartmentNote] = useState("");

    useEffect(() => {
        if (showForm === false) {
            setInEditMode({
                status: false,
                rowKey: null
            })
        }
    }, [showForm, setInEditMode])

    const handleEditRow = (departmentId, departmentName, departmentNotes) => {
        setInEditMode({
            status: true,
            rowKey: departmentId
        })
        setDepartmentName(departmentName);
        setDepartmentNote(departmentNotes);
        handleOpenForm()
        clearAlert()
    }

    const handleCancel = () => {
        setInEditMode({
            status: false,
            rowKey: null
        })
        clearAlert()
        handleCloseForm()
    }

    const handleSave = (departmentId, departmentName, departmentNotes) => {
        handleUpdateDepartment(departmentId, { departmentName, departmentNotes })
    }

    return (
        <TableRow className="vpa-table-data-row">
            <TableCell className="vpa-table-data-cell">
                {inEditMode.status && showForm && inEditMode.rowKey === department.departmentId ? (
                    <Input className="border-b-primary-fade" maxLength="50" inverted fluid value={departmentName} onChange={(event) => setDepartmentName(event.target.value)} />
                ) : (<Textfy className="page-text">{department.departmentName}</Textfy>)}
            </TableCell>
            <TableCell className="vpa-table-data-cell">
                {inEditMode.status && showForm && inEditMode.rowKey === department.departmentId ? (
                    <Input className="border-b-primary-fade" maxLength="500" inverted fluid value={departmentNotes} onChange={(event) => setDepartmentNote(event.target.value)} />
                ) : (<Textfy className="page-text">{department.departmentNotes}</Textfy>)}
            </TableCell>
            <TableCell className="vpa-table-data-cell">
                {inEditMode.status && showForm && inEditMode.rowKey === department.departmentId ? (
                    <>
                        <Button text primary iconOnly icon={<AcceptIcon />} onClick={() => handleSave(department.departmentId, departmentName, departmentNotes)} />
                        <Button text primary iconOnly onClick={() => handleCancel()} icon={<CloseIcon />} />
                    </>
                ) : (
                    <>
                        {department.itemType === "W" ? (
                            <Fragment>
                                <Button
                                    disabled={showForm}
                                    text
                                    primary
                                    onClick={() => handleEditRow(department.departmentId, department.departmentName, department.departmentNotes)}
                                    iconOnly
                                    icon={<EditIcon />} />
                                <Button
                                    disabled={showForm}
                                    text
                                    primary
                                    iconOnly
                                    icon={<TrashCanIcon />}
                                    onClick={() => { handleDeleteDepartment(department) }}
                                />
                            </Fragment>
                        ) : null}
                    </>
                )}
            </TableCell>
        </TableRow>
    )
}

export const AddDepartmentsRow = ({ handleCloseAddDepartment, handleSaveDepartment }) => {
    const [departmentName, setDepartmentName] = useState("");
    const [departmentNotes, setDepartmentNote] = useState("");

    const handleCancel = () => {
        handleCloseAddDepartment()
    }

    return (
        <TableRow className="vpa-table-data-row">
            <TableCell className="vpa-table-data-cell">
                <Input fluid className="border-b-primary-fade" maxLength="50" inverted value={departmentName} onChange={(event) => setDepartmentName(event.target.value)} />
            </TableCell>
            <TableCell className="vpa-table-data-cell">
                <Input fluid className="border-b-primary-fade" maxLength="500" inverted value={departmentNotes} onChange={(event) => setDepartmentNote(event.target.value)} />
            </TableCell>
            <TableCell className="vpa-table-data-cell">
                <Button text primary iconOnly icon={<AcceptIcon />} onClick={() => handleSaveDepartment({ departmentName, departmentNotes })} />
                <Button text primary iconOnly onClick={() => handleCancel()} icon={<CloseIcon />} />
            </TableCell>
        </TableRow>
    )

}

const mapStateToProps = (state) => ({

});

const mapActionToProps = {

};

connect(mapStateToProps, mapActionToProps)(AdminDepartmentsRow, AddDepartmentsRow);